import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import cache from 'common/util/cache'
import { replace, push } from 'react-router-redux'
import { loadStart, loadFinish, loadError } from 'common/redux/root'
import { show as showModal } from 'redux-modal'

import toastr from 'toastr'

const RESET = 'referral_list/RESET'
const LOAD = 'referral_list/LOAD'

const load = createAction(LOAD)
const reset = createAction(RESET)

export const updateReferralSearch = search => load({ search })

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

const defaultLoadHandler = dispatch => response => {
    dispatch(load(response))
    dispatch(loadFinish())
    return Promise.resolve(response)
}

export function fetchAccount(reset_=false, include_released=false) {
  return dispatch => {
    if (reset_) dispatch(reset())
    dispatch(loadStart())
    return client.post('account', {
      data: {
        include_released
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function fetchStats() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('stats')
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function fetchNotifyActive() {
  return dispatch => {
    let restored_to_active = localStorage.getItem('restored_to_active')

    if (restored_to_active) {
      localStorage.removeItem('restored_to_active')
    }

    if (restored_to_active == "true") {
      toastr.success("Lead alerts resumed!", {showDuration: 3000})
    }

    return load({notify_active: restored_to_active === "true"})
  }
}

export function restoreReleased(hash, payload) {
  return dispatch => {
    dispatch(loadStart())
    dispatch(load({restoring: hash}))
    return client.post('restore_released', {
      data: {
        hash,
        ...payload
      }
    })
    .then((response) => {
      dispatch(load(response))
      dispatch(loadFinish())
      dispatch(load({restoring: null}))
      if(!response.restored_hash) {
        toastr.error("Unable to restore this referral. Please submit a support request at https://support.realtor.com.", {showDuration: 5000})
      }

      return Promise.resolve(response)
    })
    .catch((error) => {
      dispatch(load({restoring: null}))
      dispatch(loadError(error))
      return Promise.reject(error)
    })
  }
}

const initialState = {
  search: ''
}

export default handleActions({
    [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
    [RESET]: (state, { payload }) => ({ ...initialState }),
}, initialState)
